const LANGUAGE_SCOPE_PATTERN = /^[A-Za-z0-9][A-Za-z0-9_-]{0,63}$/;

export const isSafeLanguageScope = value => (
  value != null && LANGUAGE_SCOPE_PATTERN.test(String(value))
);

export const normalizeLanguageScope = (value, fallback = 'default') => (
  isSafeLanguageScope(value)
    ? String(value)
    : (isSafeLanguageScope(fallback) ? String(fallback) : 'default')
);

export const withLanguageScope = (path, languageId, initialParams = null) => {
  const params = new URLSearchParams(initialParams || '');
  params.set('language_id', normalizeLanguageScope(languageId));
  return `${path}?${params.toString()}`;
};

export const cloudLanguageScopes = (shop, selectedLanguageId) => {
  const configured = Array.isArray(shop?.languages) ? shop.languages : [];
  const candidates = [
    'default',
    shop?.language,
    ...configured,
    selectedLanguageId,
  ];
  return [...new Set(candidates
    .filter(isSafeLanguageScope)
    .map(String))];
};

export { LANGUAGE_SCOPE_PATTERN };
